<div class="container">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="row" id="divTop" style="margin-top: 10px;margin-bottom: 10px;">
        <div class="col-md-12 col-xs-12">
          <div id="ButtonsTab" style="padding-left:5px;">
            <button id="btnSubmit" type="button" title="Submit" class="btn btn-primary"
              (click)="UpdateCouncelorAction();"
              *ngIf="(FTERecord.RequestStatusID == 3 || FTERecord.RequestStatusID == 8) && (IsCounsellor || IsAdmin)">
              <span>Submit</span>
            </button>
            <button id="btnApprove" type="button" title="Approve" class="btn btn-primary"
              (click)="OpenDialog('Approve');" *ngIf="(FTERecord.RequestStatusID == 4)  && (IsPartner || IsAdmin)">
              <span>Approve</span>
            </button>
            <button id="btnReturn" type="button" title="Return" class="btn btn-primary" (click)="OpenDialog('Return');"
              *ngIf="(FTERecord.RequestStatusID == 4  && (IsPartner || IsAdmin)) || ((FTERecord.RequestStatusID==5 || FTERecord.RequestStatusID==6 || FTERecord.RequestStatusID==7)  && (IsSLHR || IsAdmin))">
              <span>Return</span>
            </button>
            <button id="btnClose" type="button" title="Close" class="btn btn-primary" (click)="UpdateSLHRAction('Update');"
              *ngIf="(FTERecord.RequestStatusID==5 || FTERecord.RequestStatusID==6 || FTERecord.RequestStatusID==7) && (IsSLHR || IsAdmin) && (FTERecord.ClosureStatusID == 2 || FTERecord.ClosureStatusID == 3 || FTERecord.ClosureStatusID == 4 || this.FTERecord.IsLetterGenerated == true)">
              <span>Close</span>
            </button>
            <button id="btnGenerateLetter" type="button" title="Generate Letter" class="btn btn-primary"
              (click)="GenerateLetter('GenerateLetter');"
              *ngIf="FTERecord.RequestStatusID == 5 && (FTERecord.ClosureStatusID == 1) && (IsSLHR || IsAdmin) && FTERecord.EmploymentExtensionID != 4">
              <span>Generate Letter</span>
            </button>
            <button id="btnPreviewLetter" type="button" title="Preview Letter" class="btn btn-primary"
              (click)="PreviewLetter();"
              *ngIf="(FTERecord.RequestStatusID == 5 || FTERecord.RequestStatusID == 9) && (FTERecord.ClosureStatusID == 1 ) && (IsSLHR || IsAdmin) && FTERecord.IsLetterGenerated == true && FTERecord.EmploymentExtensionID != 4">
              <span>Preview Letter</span>
            </button>
            <button id="btnAttachedRevisedLetter" type="button" title="Attach Revised Letter" class="btn btn-primary"
              (click)="AttachRevisedLetter();"
              *ngIf="FTERecord.RequestStatusID == 5 && (FTERecord.ClosureStatusID == 1) && (IsAdmin) && FTERecord.IsLetterGenerated == true && FTERecord.EmploymentExtensionID != 4">
              <span>Attach Revised Letter</span>
            </button>
            <button id="btnSendMail" type="button" title="Send Mail & Close" class="btn btn-primary" (click)="SendMail();"
              *ngIf="FTERecord.RequestStatusID == 5  && (IsSLHR || IsAdmin) && (FTERecord.ClosureStatusID == 1) && FTERecord.EmploymentExtensionID != 4 && this.FTERecord.IsLetterGenerated == true">
              <span>Send Mail & Close</span>
            </button>
            <!-- added by vedha bethi on 12-jun-2021 for CR_2103_0066 -->
            <button id="btnFinanceTeamApprove" type="button" title="Approve" class="btn btn-primary"
              (click)="ActionByFinanceTeam('Approve');"
              *ngIf="(FTERecord.RequestStatusID == 11  && (IsAdmin || IsFinanceTeam))">
              <span>Approve</span>
            </button>
            <button id="btnFinanceTeamReturn" type="button" title="Return" class="btn btn-primary"
              (click)="ActionByFinanceTeam('Return');"
              *ngIf="(FTERecord.RequestStatusID == 11 && (IsAdmin || IsFinanceTeam))">
              <span>Return</span>
            </button>
             <!-- End By vedha Bethi -->

             <!-- Added By Akash Agrawal -->
            <button id="btnSLHRAndAdminReturn" type="button" title="Return" class="btn btn-primary"
              (click)="ActionBySLHRORAdmin('Return');"
              *ngIf="(FTERecord.RequestStatusID == 9 && IsAdmin)">
              <span>Return</span>
            </button>
            <!-- Ended By Akash Agrawal -->

            <button id="btnSubmit" type="button" title="Audit Trail" class="btn btn-primary"
              (click)="OpenAuditTrailDialog();"
              *ngIf="FTERecord.RequestStatusID != 3 || FTERecord.PartnerComments != null || FTERecord.SLHRReturnComments != null">
              <span>Audit Trail</span>
            </button>
            <button id="btnExit" type="button" title="Exit" class="btn btn-primary" (click)="onExit()">
              <span>Exit</span>
            </button>

          </div>
        </div>
        <div class="col-md-3 col-xs-3" style="padding-right: 0px;">
          <div style="text-align: right;padding-right:5px;margin-top:20px;">
            <h6 style="color: #808080; font-size: 13px; font-style: oblique; font-weight:bold;"></h6>
          </div>
        </div>
      </div>
      <!-- Buttons -->
      <div class="row" id="divTop" style="margin-bottom: 10px;">
        <div class="col-md-9 col-xs-9">
          <div id="divHeading" class="row" style="padding-left:5px;">
            <h5 style="color: #808080; font-style: oblique;"><b>Record ID: {{FTERecord.FTEID}}</b></h5>
          </div>
        </div>
        <div class="col-md-3 col-xs-3">
          <div class="red-status">
            <h5><b>Status: {{FTERecord.RequestStatusDesc}}</b></h5>
          </div>
        </div>
        <div class="col-md-3 col-xs-9">
          <div id="divHeading" class="row" style="padding-left:5px;">
            <h5 style="color: #808080; font-style: oblique;"></h5>
          </div>
        </div>
        <div class="col-md-9 col-xs-3" *ngIf="this.FTERecord.RequestStatusID == 3">
          <div class="red-status">
            <h5><b>Counsellor: {{this.FTERecord.EmpCouncelorName}}</b></h5>
          </div>
        </div>
        <div class="col-md-9 col-xs-3" *ngIf="this.FTERecord.RequestStatusID == 4">
          <div class="red-status">
            <h5><b>Partner: {{this.FTERecord.EmpPartnerName}}</b></h5>
          </div>
        </div>
        <div class="col-md-12 col-xs-12" *ngIf="this.FTERecord.RequestStatusID == 5">
          <div class="red-status">
            <h5><b>SL HR: {{this.FTERecord.SLHRUser}}</b></h5>
          </div>
        </div>
        <div class="col-md-9 col-xs-3" *ngIf="this.FTERecord.RequestStatusID == 11">
          <div class="red-status">
            <h5><b>Finance Team: {{this.FTERecord.FinanceUser}}</b></h5>
          </div>
        </div>
      </div>
      <div class="row" style="padding-bottom: 4px;"
        *ngIf="(FTERecord.RequestStatusID == 3 || FTERecord.RequestStatusID == 8 || FTERecord.RequestStatusID == 4 || FTERecord.RequestStatusID==5) && ((FTERecord.CurrUserGPN != FTERecord.EmpManagerGPN) || (FTERecord.CurrUserGPN != FTERecord.EmpPartnerGPN) || (FTERecord.CurrUserGPN != FTERecord.EmpCouncelorGPN))">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <label class="control-label" style="width: 105%; color: red; font-family: 'Times New Roman', Times, serif;">
            <marquee id="marquee" onmouseover="this.stop();" onmouseout="this.start();" scrollamount="6">
              <i>
                “EY does not intentionally collect any sensitive personal data from you via the Tool. The Tool’s
                intention is not to process such information.”
              </i>
            </marquee>
          </label>
        </div>
      </div>
      <div class="row" *ngIf="ErrorMessage.length > 0">
        <div class="col-md-12">
          <div style="font-size:small;">
            <img src="assets/img/error_icon.gif" /><span class="text-error" style="font-weight:bold;color:red;">
              The
              following errors were encountered on the page.
            </span>
          </div>
          <div id="divMainError" class="text-error"
            style="padding-top:0px; margin-bottom:10px;margin-left:25px; font-size:small; color:red">
            <span style="display:list-item" *ngFor="let item of ErrorMessage">{{item.message}}</span>
          </div>
        </div>
      </div>
      <div class="employee-details-wrapper">
        <div class="row">
          <div class="col-md-12">
            <div class="panel-heading">
              <h4 class="panel-title">
                <a style="color: gray; font-size: 14px;">
                  <b>Employee Details</b>
                </a>
              </h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Employee LPN</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpLPN}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Employee GPN</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpGPN}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Employee Name</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpName}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Email ID</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpEmail}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Service Line</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.ServiceLine}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Title</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpTitle}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Location</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpLocation}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Office Address</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpOfficeAddress}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Contract End Date</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpContractEndDate | date:"dd-MMM-yyyy"}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Counsellor</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpCouncelorName}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Manager</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpManagerName}}
                    </div>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Partner</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpPartnerName}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Joining Date</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpJoiningDate | date:"dd-MMM-yyyy"}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Mobile No.</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpMobile}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>CUG</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpCUG}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Legal Entity</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpLegalEntity}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Market Segment</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpBUDesc}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Status</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmpStatus}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Employee Type</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.EmployeeType}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Competency Name</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.CompetencyName}}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mb-2">
                  <div class="row">
                    <span class="col-sm-4"><b>Activity Type</b></span>
                    <div class="col-md-8 col-sm-8">
                      {{FTERecord.ActivityType}}
                    </div>
                  </div>
                </div>
              </div> <!-- /.row  -->
            </div> <!-- /.panel-body -->
          </div> <!-- /.col-md-12 -->
        </div>
      </div>
      <div class="current-compensation-wrapper">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a style="color: gray; font-size: 14px;">
              <b>Current Compensation Details</b>
            </a>
          </h4>
        </div>
        <div class="panel-body">
          <div class="row">
            <div class="col-md-6">
              <div class="row">
                <span class="col-sm-4"><b>Last Increment Date</b></span>
                <div class="col-md-8 col-sm-8">
                  <div class="input-group date">
                    <input matInput class="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="LastIncrement"
                       placeholder="Choose a date" [(ngModel)]="FTERecord.LastIncrementDate" disabled
                      [min]="minDateLID" [max]="maxDateLID">
                    <mat-datepicker-toggle matSuffix [for]="LastIncrement">
                    </mat-datepicker-toggle>
                    <mat-datepicker #LastIncrement [disabled]="FTERecord.RequestStatusID == 9">
                    </mat-datepicker>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row">
                <span class="col-sm-4"><b>Total CTC</b></span>
                <div class="col-md-8 col-sm-8">
                  <span
                    id="txtTotalCTC">{{FTERecord.TotalCTC}}</span><span>/-&nbsp;&nbsp;({{FTERecord.TotalCTCWords}})</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="counsellor-remark">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a style="color: gray; font-size: 14px;">
              <b>Counsellor's Remarks</b>
            </a>
          </h4>
        </div>
        <div class="panel-body">
          <div class="row">
            <div class="col-md-6">
              <div class="row" style="padding-top:7px;">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Employment Extension</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <select id="ddlEmploymentExtension" class="form-control"
                              [(ngModel)]="FTERecord.EmploymentExtensionID"
                              (change)="SetTextValue($event,'EmploymentExtension');"
                              [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam">
                        <option value="0">Select</option>
                        <option *ngFor="let item of EmploymentExtensionList" value={{item.KeyWordValue}}>
                          {{item.KeyWordText}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-top:7px;"
                   *ngIf="FTERecord.EmploymentExtensionID == 3 || FTERecord.EmploymentExtensionID == 0 || FTERecord.EmploymentExtensionID == 4">
                <div class="col-md-12" *ngIf="!IsConversionCycleDate">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Conversion Cycle</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <select id="ddlConversionCycle" class="form-control"
                              [(ngModel)]="FTERecord.ConversionCycleID"
                              (change)="SetTextValue($event,'ConversionCycle');"
                              [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam">
                        <option value="0">Select</option>
                        <option *ngFor="let item of ConversionCycleList" value={{item.KeyWordValue}}>
                          {{item.KeyWordText}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <!-- Added by Utkarsh for CR_2311_0209 -->
                <div class="col-md-12" *ngIf="IsConversionCycleDate">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Proposed Conversion Date</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <div class="input-group date">
                        <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="ConversionCycleDate"
                                               placeholder="Choose a date" [(ngModel)]="FTERecord.ConversionCycleDate" disabled
                                               (dateChange)="ChangeDateFormat($event)" [min]="this.FTERecord.EmpContractEndDate">
                          <mat-datepicker-toggle matSuffix [for] ="ConversionCycleDate">
                            </mat-datepicker-toggle>
                            <mat-datepicker #ConversionCycleDate [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam">
                              </mat-datepicker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-top:7px;" *ngIf="FTERecord.EmploymentExtensionID == 4">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Proposed Next Contract End Date</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <div class="input-group date">
                        <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="txtProposedContractEndDate"
                                               placeholder="Choose a date" [(ngModel)]="FTERecord.ProposedContractEndDateRetain" disabled
                                              >
                          <mat-datepicker-toggle matSuffix [for] ="txtProposedContractEndDate">
                            </mat-datepicker-toggle>
                            <mat-datepicker #txtProposedContractEndDate [disabled]="true">
                              </mat-datepicker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-top:7px;" *ngIf="FTERecord.EmploymentExtensionID  !=2">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4">
                      <b>Client engagement deployed on </b><span style="color: red;">*</span>
                    </span>
                    <div class="col-md-8 col-sm-8">
                      <input type="textarea" id="txtCouncelorComment" name="txtCouncelorComment" maxlength="500"
                             class="form-control" [(ngModel)]="FTERecord.CouncelorComment"
                             [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam"
                             autocomplete="off" (keypress)="blockSpecialChar($event)" #txtCouncelorComment="ngModel" pattern="^[a-zA-Z0-9\s]*$">
                      <div *ngIf="((txtCouncelorComment.dirty || txtCouncelorComment.touched) && txtCouncelorComment.invalid)"
                           class="text-danger">Invalid input.</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- || FTERecord.EmploymentExtensionID == 3 Commented By Aakash Agrawal For CR_2501_0010 -->
              <div class="row" style="padding-top:7px;"
                   *ngIf="FTERecord.EmploymentExtensionID == 1 || FTERecord.EmploymentExtensionID == 4 || FTERecord.EmploymentExtensionID == 0">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4">
                      <b>Feedback</b><span style="color: red;">*</span><span style="padding-left: 5px;" class="pi pi-info-circle" title="1. Met Partial Expectation - Needs improvement in identified performance areas 2. Meets Expectation - Consistently meets performance standards 3. Exceed Expectation - Usually exceeds performance standards 4. Exceptional Performance - Significantly exceeded expectations compared to relevant peer group"></span>
                    </span>
                    <div class="col-md-8 col-sm-8">
                      <select id="ddlRecommendation" class="form-control"
                              [(ngModel)]="FTERecord.CouncelorRecommendationID"
                              (change)="SetTextValue($event,'Recommendation');"
                              [disabled]="FTERecord.EmploymentExtensionID == 2 || IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam">
                        <option value="0">Select</option>
                        <option *ngFor="let item of CouncelorRecommendationList" value={{item.KeyWordValue}}
                                title={{item.ToolTipText}}>
                          {{item.KeyWordText}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-top:7px;" *ngIf="FTERecord.EmploymentExtensionID != 2">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Project Location</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <select id="ddlLocation" class="form-control" [(ngModel)]="FTERecord.ProjectLocationID"
                              (change)="SetTextValue($event,'ProjectLocation');"
                              [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam">
                        <option value="0">Select</option>
                        <option *ngFor="let item of LocationMasterList" value={{item.KeyWordValue}}>
                          {{item.KeyWordText}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-top:7px;" *ngIf="FTERecord.EmploymentExtensionID == 2">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Last Working Day</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <div class="input-group date">
                        <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="txtLastWorkingDay"
                                               placeholder="Choose a date" [(ngModel)]="LastWorkingDayDate" (dateChange)="LastWorkingDayDateChange($event)" disabled
                                              [min]="minLastWorkingDate">
                          <mat-datepicker-toggle matSuffix [for] ="txtLastWorkingDay">
                            </mat-datepicker-toggle>
                            <mat-datepicker #txtLastWorkingDay [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam">
                              </mat-datepicker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-top:7px;"
                   *ngIf="FTERecord.EmploymentExtensionID == 1 && FTERecord.IsRecordCretedAfterCutOfDate">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Performance </b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <input type="textarea" id="txtPerformance" name="txtPerformance" maxlength="200"
                             class="form-control" [(ngModel)]="FTERecord.Performance"
                             [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam"
                             autocomplete="off" (keypress)="blockSpecialChar($event)" #txtPerformance="ngModel" pattern="^[a-zA-Z0-9\s]*$">
                      <div *ngIf="((txtPerformance.dirty || txtPerformance.touched) && txtPerformance.invalid)"
                           class="text-danger">Invalid input.</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-top:7px;"
                   *ngIf="FTERecord.EmploymentExtensionID == 1 && FTERecord.IsRecordCretedAfterCutOfDate">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Utilization % </b><span *ngIf="FTERecord.EmpMarketSegment == 'GPS'" style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <input type="text" (keypress)="numberOnly($event)" id="txtUtilization" name="txtUtilization"
                             maxlength="3" class="form-control" [(ngModel)]="FTERecord.Utilization" #txtUtilization="ngModel" pattern="^[0-9\s]*$"
                             [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam"
                             autocomplete="off">
                      <div *ngIf="((txtUtilization.dirty || txtUtilization.touched) && txtUtilization.invalid)"
                           class="text-danger">Invalid input.</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-top:7px;"
                   *ngIf="FTERecord.EmploymentExtensionID == 1 && FTERecord.IsRecordCretedAfterCutOfDate">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Yearly Billing </b><span *ngIf="FTERecord.EmpMarketSegment == 'GPS'" style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <input type="textarea" (keypress)="numberOnly($event)" id="txtYearlyBilling"
                             name="txtYearlyBilling" maxlength="20" class="form-control"
                             [(ngModel)]="FTERecord.YearlyBilling" #txtYearlyBilling="ngModel" pattern="^[0-9\s]*$"
                             [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam"
                             (change)="Validate($event,'YearlyBillingMinValueChk')" autocomplete="off">
                      <div *ngIf="((txtYearlyBilling.dirty || txtYearlyBilling.touched) && txtYearlyBilling.invalid)"
                           class="text-danger">Invalid input.</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-top:7px;"
                   *ngIf="FTERecord.EmploymentExtensionID == 1 && FTERecord.IsRecordCretedAfterCutOfDate">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>GM % </b><span *ngIf="FTERecord.EmpMarketSegment == 'GPS'" style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <input type="textarea" (keypress)="numberOnly($event)" id="txtGM" name="txtGM" maxlength="3"
                             class="form-control" [(ngModel)]="FTERecord.GM" #txtGM="ngModel" pattern="^[0-9\s]*$"
                             [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam"
                             autocomplete="off">
                      <div *ngIf="((txtGM.dirty || txtGM.touched) && txtGM.invalid)"
                           class="text-danger">Invalid input.</div>
                    </div>
                  </div>
                </div>
              </div>
              <!--Added by Utkarsh for CR_2311_0209-->
              <div class="row" style="padding-top:7px;" *ngIf="(FTERecord.EmploymentExtensionID ==2 || FTERecord.EmploymentExtensionID ==3) || (FTERecord.EmpMarketSegment == 'NonGPS' && (FTERecord.ServiceLine == 'Tax' || this.FTERecord.ServiceLine == 'Forensics' || this.FTERecord.ServiceLine == 'Assurance'))">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Partner Approval</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <input type="File" id="" name="file" (change)="UploadPartnerApproval($event)"
                             class="form-control"
                             *ngIf="FTERecord.PartnerApprAttachmentList.length == 0 && FTERecord.RequestStatusID != 9"
                             accept=".png,.jpeg,.msg,.pdf" style="width: 80%"
                             [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam">
                      <span *ngIf="FTERecord.PartnerApprAttachmentID == 0 && FTERecord.RequestStatusID==9">
                        No Attachments
                      </span>
                      <span>
                        <a (click)="GetAttachmentbyAttachmentID(FTERecord.PartnerApprAttachmentID,'PartnerApproval')"
                           style="cursor:pointer;color: blue;">{{FTERecord.PartnerApprAttachmentName}}</a>
                      </span>
                      <span style="color: blue; cursor: pointer; padding-left: 10px;"
                            *ngIf="FTERecord.PartnerApprAttachmentList.length > 0 && FTERecord.RequestStatusID != 9"
                            (click)="DeletePartnerApprUploadedFile()" class="pi pi-trash"></span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="row" style="padding-top:7px;"
                *ngIf="(FTERecord.EmploymentExtensionID == 1 || FTERecord.EmploymentExtensionID == 3 || FTERecord.EmploymentExtensionID == 4 || FTERecord.EmploymentExtensionID == 0) && (this.FTERecord.ExtensionTypeID == 1 || this.FTERecord.ExtensionTypeID == 0)">
                <div class="col-md-12">
                  <div class="form-group">
                    <span class="col-sm-4"><b>Increment (in %)</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <input type="number" id="txtIncrementByCouncelor" name="txtIncrementByCouncelor"
                        maxlength="5" (keydown)="AllowOnlyDecimalNumbers($event)"
                        (change)="Validate($event,'IncrementByCouncelor')" class="form-control"
                        [(ngModel)]="FTERecord.IncrementInPercentByCouncelor"
                        [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || FTERecord.RequestStatusID == 3 || FTERecord.RequestStatusID == 8 || IsFinanceTeam"
                        autocomplete="off">
                    </div>
                  </div>
                </div>
              </div> -->
            </div> <!-- /.col-md-6  inline-->
            <!-- FTERecord.EmploymentExtensionID == 3 || Commented by Akash Agrawal For CR_2501_0010 -->
            <div class="col-md-6">
              <div class="row" style="padding-top:7px;"
                   *ngIf="FTERecord.EmploymentExtensionID == 1 || FTERecord.EmploymentExtensionID == 4  || FTERecord.EmploymentExtensionID == 0">
                <div class="col-md-12">
                  <div class="row form-group" [ngStyle]="{'display' : FTERecord.EmploymentExtensionID == 4 ? 'none' : 'flex'}">
                    <span class="col-sm-4"><b>Tenure of Extension</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <select id="ddlTenureOfExtensionByCouncelor" class="form-control"
                              [(ngModel)]="FTERecord.TenureOfExtensionByCouncelorID"
                              (change)="SetTextValue($event,'TenureOfExtensionByCouncelor');"
                              [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam">
                        <option value="0">Select</option>
                        <option *ngFor="let item of TenureOfExtensionByCouncelorList" value={{item.KeyWordValue}}>
                          {{item.KeyWordText}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row form-group"
                       [ngStyle]="{'display' : FTERecord.EmploymentExtensionID == 4 ? 'flex' : 'none'}">
                    <span class="col-sm-4"><b>Tenure of Retainership</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <select id="ddlTenureOfRetainByCouncelor" class="form-control"
                              [(ngModel)]="FTERecord.TenureOfRetainByCouncelorID"
                              (change)="SetTextValue($event,'TenureOfRetainByCouncelor');"
                              [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam">
                        <option value="0">Select</option>
                        <option *ngFor="let item of TenureOfRetentionByCouncelorList" value={{item.KeyWordValue}}>
                          {{item.KeyWordText}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Added by Utkarsh for CR_2311_0209 START -->
              <div class="row" style="padding-top:7px;"
                   *ngIf="FTERecord.TenureOfExtensionByCouncelorID && (FTERecord.EmploymentExtensionID == 1 || FTERecord.EmploymentExtensionID == 4 || FTERecord.EmploymentExtensionID == 3 || FTERecord.EmploymentExtensionID == 0)">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Proposed Next Contract End Date</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <div class="input-group date">
                        <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="ProposedNextEndDate"
                                               placeholder="Choose a date" [(ngModel)]="ProposedEndDate" disabled>
                          <mat-datepicker-toggle matSuffix [for] ="ProposedNextEndDate">
                            </mat-datepicker-toggle>
                            <mat-datepicker #ProposedNextEndDate [disabled]="true"></mat-datepicker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Added by Utkarsh for CR_2311_0209 END -->
               <!-- FTERecord.EmploymentExtensionID == 3 || [disabled]="!(IsCounsellor || IsAdmin)" Commented by Akash Agrawal For CR_2501_0010 -->
              <div class="row" style="padding-top:7px;"
                   *ngIf="FTERecord.EmploymentExtensionID == 1 || FTERecord.EmploymentExtensionID == 4 || FTERecord.EmploymentExtensionID == 0">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Extension Type</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <select id="ddlExtensionType" class="form-control" [(ngModel)]="FTERecord.ExtensionTypeID"
                              (change)="SetTextValue($event,'ExtensionType');"
                               [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam">
                        <option value="0">Select</option>
                        <option *ngFor="let item of ExtensionTypeList" value={{item.KeyWordValue}}>
                          {{item.KeyWordText}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <!--Added by Utkarsh for CR_2311_0209-->
              <!-- //[disabled]="!(IsCounsellor || IsAdmin)" commented by Akash Agrawal -->
              <div class="row" style="padding-top: 7px;" *ngIf="FTERecord.ExtensionTypeID == 1 || FTERecord.EmploymentExtensionID == 3">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Proposed CTC </b></span>
                    <div class="col-md-8 col-sm-8">
                      <input type="textarea" (keypress)="numberOnly($event)" id="ProposedCTC"
                             name="ProposedCTC" maxlength="15" class="form-control"
                             [(ngModel)]="FTERecord.ProposedCTC" #ProposedCTC="ngModel" pattern="^[0-9\s]*$"
                             [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam"
                             autocomplete="off">
                      <div *ngIf="((ProposedCTC.dirty || ProposedCTC.touched) && ProposedCTC.invalid)"
                           class="text-danger">Invalid input.</div>
                    </div>
                  </div>
                </div>
              </div>
              <!--Added  by Shreya CR_2303_0039-->
              <div class="row" style="padding-top:7px;" *ngIf="FTERecord.EmploymentExtensionID == 0 || FTERecord.EmploymentExtensionID == 1 || FTERecord.EmploymentExtensionID == 4">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Engagement code</b></span>
                    <div class="col-md-8 col-sm-8">
                      <p-autoComplete [(ngModel)]="Engcode" [suggestions]="filteredEngagementSingle" autocomplete="off"
                                      (completeMethod)="GetEngagementSearch($event)" field="Engcode" [size]="30"
                                      placeholder="Enter Engagement code for Search" [minLength]="3"
                                      aria-describedby="basic-addon3" name="Engcode" (onClear)="OnClearEngagement()"
                                      [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam"
                                      (onSelect)="SetSelectedEngagement($event)" [forceSelection]="true"
                                      (keydown.space)="$event.preventDefault();" [style]="{'width':'100%', 'height':'40px', 'font-size': '14px'}" [inputStyle]="{'width':'100%'}"></p-autoComplete>

                      <!--Added  by Shreya CR_2303_0039-->
                    </div>
                    <span class="col-sm-4"><b></b></span>
                    <div class="col-md-8 col-sm-8">
                    <span><b>{{FTERecord.EngTitle}}</b></span>
                  </div>
                  </div>
                </div>
              </div>
              <!-- *ngIf="FTERecord.EmploymentExtensionID != 3"  Added By Akash Agrawal For CR_2501_0010-->
              <div class="row" style="padding-top:7px;" *ngIf="FTERecord.EmploymentExtensionID == 0 || FTERecord.EmploymentExtensionID == 1 || FTERecord.EmploymentExtensionID == 4">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Client Engagement End Date </b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <div class="input-group date">
                        <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="txtScopeofWork"
                                               placeholder="Choose a date" [(ngModel)]="CouncelorScopeofWorkDate" (dateChange)="CouncelorScopeofWorkChange($event)" disabled>
                          <mat-datepicker-toggle matSuffix [for] ="txtScopeofWork">
                            </mat-datepicker-toggle>
                            <mat-datepicker #txtScopeofWork [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam">
                              </mat-datepicker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-top:7px;"
                   *ngIf="FTERecord.EmploymentExtensionID == 1 && FTERecord.IsRecordCretedAfterCutOfDate">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Detailed Business Case </b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <input type="text" id="txtDetaildBuinessCase" name="txtDetaildBuinessCase"
                             maxlength="1000" class="form-control" [(ngModel)]="FTERecord.DetaildBuinessCase"
                             [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam"
                             autocomplete="off" (keypress)="blockSpecialChar($event)" #txtDetaildBuinessCase="ngModel">
                      <div *ngIf="((txtDetaildBuinessCase.dirty || txtDetaildBuinessCase.touched) && txtDetaildBuinessCase.invalid)"
                           class="text-danger">Invalid input.</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-top:7px;"
                   *ngIf="FTERecord.EmploymentExtensionID == 1 && FTERecord.IsRecordCretedAfterCutOfDate">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Monthly Billing </b><span *ngIf="FTERecord.EmpMarketSegment == 'GPS'" style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <input type="textarea" (keypress)="numberOnly($event)" id="txtMonthlyBilling"
                             name="txtMonthlyBilling" maxlength="10" class="form-control"
                             [(ngModel)]="FTERecord.MonthlyBilling" #txtMonthlyBilling="ngModel" pattern="^[0-9\s]*$"
                             [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam"
                             (change)="Validate($event,'MonthlyBillingMinValueChk')" autocomplete="off">
                      <div *ngIf="((txtMonthlyBilling.dirty || txtMonthlyBilling.touched) && txtMonthlyBilling.invalid)"
                           class="text-danger">Invalid input.</div>
                    </div>
                  </div>
                </div>
              </div>
              <!--Added  by Shreya CR_2303_0039-->
              <div class="row" style="padding-top:7px;" *ngIf="FTERecord.IsRecordCretedAfterCutOfDate">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Remarks/Any additional inputs </b></span>
                    <div class="col-md-8 col-sm-8">
                      <input type="textarea" id="txtRemark" name="txtRemark" maxlength="200" class="form-control"
                             [(ngModel)]="FTERecord.Remark" (keypress)="blockSpecialChar($event)" #txtRemark="ngModel" pattern="^[a-zA-Z0-9\s]*$"
                             [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam"
                             autocomplete="off">
                      <div *ngIf="((txtRemark.dirty || txtRemark.touched) && txtRemark.invalid)"
                           class="text-danger">Invalid input.</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="padding-top:7px;"
                   *ngIf="FTERecord.EmploymentExtensionID == 1 && FTERecord.IsRecordCretedAfterCutOfDate">
                <div class="col-md-12">
                  <div class="row form-group">
                    <!-- <span class="col-sm-4"><b>Client Engagement Letter</b><span
                        style="color: red;">*</span></span> -->
                    <!--Modified by Utkarsh for CR_2311_0209-->
                    <span class="col-sm-4"><b>Attachment</b></span>
                    <div class="col-md-8 col-sm-8">
                      <input type="File" id="" name="file" (change)="UploadClientEngLetter($event)"
                             class="form-control"
                             *ngIf="FTERecord.ClientEngAttachmentList.length == 0 && FTERecord.RequestStatusID != 9"
                             accept=".png,.jpeg,.msg,.pdf,.eml,.doc,.zip" style="width: 80%"
                             [disabled]="IsDisableForSLHR || FTERecord.RequestStatusID == 9 || IsFinanceTeam">
                      <span *ngIf="FTERecord.ClientEngAttachmentID == 0 && FTERecord.RequestStatusID==9">
                        No
                        Attachments
                      </span>
                      <span>
                        <a (click)="GetAttachmentbyAttachmentID(FTERecord.ClientEngAttachmentID,'ClientEngagementLetter')"
                           style="cursor:pointer;color: blue;">{{FTERecord.ClientEngAttachmentName}}</a>
                      </span>
                      <span style="cursor: pointer;color: blue; padding-left: 10px;"
                            *ngIf="FTERecord.ClientEngAttachmentList.length > 0 && FTERecord.RequestStatusID != 9"
                            (click)="DeleteClientEngLetter()" class="pi pi-trash"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div> <!-- /.col-md-6  -->
          </div><!-- /.row  -->
        </div><!-- /.panel-body -->
      </div> <!-- /.counsellor-remark -->
      <div class="closure-action-wrapper mb-4" style="margin-left:2px; margin-right:2px;" id="rowActionByFinanceTeam"
           *ngIf="((FTERecord.RequestStatusID==11 || FTERecord.RequestStatusID==6  || FTERecord.RequestStatusID==5 || FTERecord.RequestStatusID==7) && ((IsFinanceTeam) || (IsAdmin) || IsSLHR))
        && !(FTERecord.EmpMarketSegment == 'NonGPS' && FTERecord.ServiceLine == 'Tax')">
            <div class="panel-heading">
              <h4 class="panel-title">
                <a style="color: gray; font-size: 14px;">
                  <b>Finance Team's Section</b>
                </a>
              </h4>
            </div>
            <div class="panel-body">
              <div class="row" style="padding-top:7px;">
                <div class="col-md-6">
                  <div class="row form-group" >
                    <span class="col-sm-4"><b>Remarks/Any additional inputs</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <input type="text" id="txtFinanceTeamRemarks" name="txtFinanceTeamRemarks" maxlength="200"
                                 class="form-control" [(ngModel)]="FTERecord.FinanceTeamRemarks"
                                 [disabled]="FTERecord.RequestStatusID == 9 || IsDisableForFinance" autocomplete="off"
                                 (keypress)="blockSpecialChar($event)" #txtFinanceTeamRemarks="ngModel" pattern="^[a-zA-Z0-9\s]*$">
                          <div *ngIf="((txtFinanceTeamRemarks.dirty || txtFinanceTeamRemarks.touched) && txtFinanceTeamRemarks.invalid)"
                               class="text-danger">Invalid input.</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6" *ngIf="!IsFinContractEndDate">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Extension (in months)</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <select id="ddlExtensionByFinanceTeam" class="form-control"
                                  [(ngModel)]="FTERecord.ExtensionByFinanceTeamID"
                                  (change)="SetTextValue($event,'ExtensionByFinanceTeam');"
                                  [disabled]="FTERecord.RequestStatusID == 9 || IsDisableForFinance">
                            <option value="">Select</option>
                            <option *ngFor="let item of TenureOfExtensionByFinanceList" value={{item.KeyWordValue}}>
                              {{item.KeyWordText}}
                            </option>
                          </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-6" *ngIf="IsFinContractEndDate">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Next Contract End Date</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <div class="input-group date">
                        <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="FinContractEndDate"
                                               placeholder="Choose a date" [(ngModel)]="FTERecord.FinContractEndDate" (dateChange)="OnNextContractEndDateFinance()" disabled
                                              [min]="minFinContractEndDate">
                          <mat-datepicker-toggle matSuffix [for] ="FinContractEndDate">
                            </mat-datepicker-toggle>
                            <mat-datepicker #FinContractEndDate [disabled]="FTERecord.RequestStatusID == 9 || IsDisableForFinance">
                              </mat-datepicker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
      </div>

      <div class="closure-action-wrapper mb-4" id="rowActionByFinanceTeam" *ngIf="((FTERecord.RequestStatusID==5 || FTERecord.RequestStatusID==6 || FTERecord.RequestStatusID==7) && (IsSLHR || IsAdmin)) || FTERecord.RequestStatusID==9">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a style="color: gray; font-size: 14px;">
              <b>Closure Action by SL HR</b>
            </a>
          </h4>
        </div>
        <div class="panel-body">
          <div class="row" style="padding-top:7px;">
            <div class="col-md-6">
              <div class="row form-group">
                <span class="col-sm-4"><b>Closure Status</b><span style="color: red;">*</span></span>
                <div class="col-md-8 col-sm-8">
                  <select id="ddlClosureStatusBySLHR" class="form-control"
                          [(ngModel)]="FTERecord.ClosureStatusID"
                          (change)="SetTextValue($event,'ClosureStatusBySLHR');"
                          [disabled]="FTERecord.RequestStatusID == 9">
                    <option value="">Select</option>
                    <option *ngFor="let item of ClosureStatusList" value={{item.KeyWordValue}}>
                      {{item.KeyWordText}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row form-group">
                <span class="col-sm-4"><b>Upload Extension Letter / any supporting document</b></span>
                <div class="col-md-8 col-sm-8">
                  <input type="File" id="" name="file" (change)="UploadAttachment($event)" class="form-control"
                         *ngIf="FTERecord.AttachmentList.length == 0 && FTERecord.RequestStatusID != 9"
                         accept=".png,.jpeg,.msg,.pdf" style="width: 80%">
                  <span *ngIf="FTERecord.AttachmentID == 0 && FTERecord.RequestStatusID==9">
                    No
                    Attachments
                  </span>
                  <span>
                    <a (click)="GetAttachmentbyAttachmentID(FTERecord.AttachmentID,'')"
                       style="cursor:pointer;color: blue;">{{FTERecord.AttachmentName}}</a>
                  </span>
                  <span style="color: blue; cursor: pointer; padding-left: 10px;"
                        *ngIf="FTERecord.AttachmentList.length > 0 && FTERecord.RequestStatusID != 9"
                        (click)="DeleteUploadedFile()" class="pi pi-trash"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="padding-top:7px;" *ngIf="FTERecord.ClosureStatusID == 2">
            <div class="col-md-6">
              <div class="row form-group">
                <span class="col-sm-4">
                  <b>Last Working Day</b><span style="color: red;">*</span>
                </span>
                <div class="col-md-8 col-sm-8">
                  <div class="input-group date">
                        <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="txtLastWorkingDaySLHR"
                                               placeholder="Choose a date" [(ngModel)]="LastWorkingDayDateSLHR" (dateChange)="LastWorkingDayDateChangeSLHR($event)" disabled
                                              [min]="minLastWorkingDate">
                          <mat-datepicker-toggle matSuffix [for] ="txtLastWorkingDaySLHR">
                            </mat-datepicker-toggle>
                            <mat-datepicker #txtLastWorkingDaySLHR [disabled]="FTERecord.RequestStatusID == 9">
                              </mat-datepicker>
                      </div>
</div>
              </div>
            </div>
          </div>
          <div class="row" style="padding-top:7px;">
            <div class="col-md-6">
              <div class="row form-group"
                   *ngIf="FTERecord.ClosureStatusID == 1 || FTERecord.ClosureStatusID == 4">
                <span class="col-sm-4">
                  <b>{{FTERecord.ClosureStatusID == 1 ? 'Tenure of Extension (in months)' : 'Tenure of Retainership (in months)'}}</b><span style="color: red;">*</span>
                </span>
                <div class="col-md-8 col-sm-8">
                  <select id="ddlTenureOfExtensionBySLHR" class="form-control"
                          [(ngModel)]="FTERecord.TenureOfExtensionBySLHRID"
                          (change)="SetTextValue($event,'TenureOfExtensionBySLHR');"
                          [disabled]="FTERecord.RequestStatusID == 9">
                    <option value="">Select</option>
                    <option *ngFor="let item of TenureOfExtensionBySLHRList" value={{item.KeyWordValue}}>
                      {{item.KeyWordText}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row form-group"
                   *ngIf="FTERecord.ClosureStatusID == 1 || FTERecord.ClosureStatusID == 4">
                <span class="col-sm-4">
                  <b>Finalized Increment(in %)</b><span style="color: red;">*</span>
                </span>
                <!-- (change)="Validate($event,'IncrementBySLHR')" Commented by Akash Agrawal for CR_2501_0010 -->
                <div class="col-md-8 col-sm-8">
                  <input type="number" id="txtIncrementBySLHR" name="txtIncrementBySLHR" maxlength="5"
                         class="form-control" [(ngModel)]="FTERecord.IncrementInPercentBySLHR"
                         [disabled]="true" (keydown)="AllowOnlyDecimalNumbers($event)"
                          autocomplete="off" #txtIncrementBySLHR="ngModel" pattern="^[0-9]*\.?[0-9]+$">
                  <div *ngIf="((txtIncrementBySLHR.dirty || txtIncrementBySLHR.touched) && txtIncrementBySLHR.invalid)"
                       class="text-danger">Invalid input.</div>
                </div>
              </div>
            </div>
          </div> <!-- /.row  -->
          <div class="row" style="padding-top:7px;">
            <div class="col-md-6">
              <div class="row form-group"
                   *ngIf="FTERecord.ClosureStatusID == 1 || FTERecord.ClosureStatusID == 4">
                <span class="col-sm-4"><b>Next Contract End Date</b><span style="color: red;">*</span></span>
                <div class="col-md-8 col-sm-8">
                  <div class="input-group date">
                    <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="CouncelorSubTo"
                                           placeholder="Choose a date" [(ngModel)]="FTERecord.NextContractEndDate" disabled
                                          [min]="minDate" [max]="maxDate" (dateChange)="OnNextContractEndDate()">
                      <mat-datepicker-toggle matSuffix [for] ="CouncelorSubTo">
                        </mat-datepicker-toggle>
                        <mat-datepicker #CouncelorSubTo [disabled]="FTERecord.RequestStatusID == 9"></mat-datepicker>
                  </div>
                </div>
              </div>
            </div>
            <!--Added by Utkarsh for CR_2311_0209-->
            <div class="col-md-6">
              <div class="row form-group"
                   *ngIf="FTERecord.ClosureStatusID == '3' || FTERecord.ClosureStatusID == '4'">
                <span class="col-sm-4"><b>NHP SR number</b><span style="color: red;">*</span></span>
                <div class="col-md-8 col-sm-8">
                  <input type="text" id="txtNHPSrNumberBySLHR" name="txtNHPSrNumberBySLHR" maxlength="100"
                         class="form-control" [(ngModel)]="FTERecord.NHPSrNumber"
                         [disabled]="FTERecord.RequestStatusID == 9" autocomplete="off"
                         (keypress)="blockSpecialChar($event)" #txtNHPSrNumberBySLHR="ngModel" pattern="^[a-zA-Z0-9\s]*$">
                  <div *ngIf="((txtNHPSrNumberBySLHR.dirty || txtNHPSrNumberBySLHR.touched) && txtNHPSrNumberBySLHR.invalid)"
                       class="text-danger">Invalid input.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="padding-top:7px;" *ngIf="(FTERecord.EmploymentExtensionID == 1 || FTERecord.EmploymentExtensionID == 4 || FTERecord.EmploymentExtensionID == 0) && (FTERecord.ClosureStatusID == 1 || FTERecord.ClosureStatusID == 4 || FTERecord.ClosureStatusID == 0)">
                <div class="col-md-6">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Extension Type</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <select id="ddlExtensionType" class="form-control" [(ngModel)]="FTERecord.ExtensionTypeIDSLHR"
                              (change)="SetTextValue($event,'ExtensionTypeSLHR');" [disabled]="FTERecord.RequestStatusID == 9">
                        <option value="0">Select</option>
                        <option *ngFor="let item of ExtensionTypeList" value={{item.KeyWordValue}}>
                          {{item.KeyWordText}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-6" *ngIf="FTERecord.ExtensionTypeIDSLHR == 1 || FTERecord.EmploymentExtensionID == 3">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Proposed CTC</b></span>
                    <div class="col-md-8 col-sm-8">
                      <input type="textarea" (keypress)="numberOnly($event)" id="ProposedCTC"
                             name="ProposedCTC" maxlength="15" class="form-control"
                             [(ngModel)]="FTERecord.ProposedCTCSLHR" #ProposedCTC="ngModel" pattern="^[0-9\s]*$"
                             [disabled]="FTERecord.RequestStatusID == 9"
                             autocomplete="off"  (change)="OnProposedCTCChange('change')">
                      <div *ngIf="((ProposedCTC.dirty || ProposedCTC.touched) && ProposedCTC.invalid)"
                           class="text-danger">Invalid input.</div>
                    </div>
                  </div>
                </div>
          </div>
          <div class="row" style="padding-top:7px;" *ngIf="FTERecord.ClosureStatusID == 3">
                <div class="col-md-6">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Proposed Conversion Date</b><span style="color: red;">*</span></span>
                    <div class="col-md-8 col-sm-8">
                      <div class="input-group date">
                        <input matInput class ="form-control" style="width: 250px; font-size: 14px;" [matDatepicker]="ConversionCycleDateSLHR"
                                               placeholder="Choose a date" [(ngModel)]="FTERecord.ConversionCycleDateSLHR" disabled
                                               (dateChange)="ChangeDateFormatSLHR($event)" [min]="this.FTERecord.EmpContractEndDate">
                          <mat-datepicker-toggle matSuffix [for] ="ConversionCycleDateSLHR">
                            </mat-datepicker-toggle>
                            <mat-datepicker #ConversionCycleDateSLHR [disabled]="FTERecord.RequestStatusID == 9">
                              </mat-datepicker>
                      </div>
                    </div>
                  </div>
                </div>
          </div>
          <div class="row" style="padding-top:7px;">
            <div class="col-md-12">
              <div class="row form-group">
                <span class="col-sm-2"><b>Closure Comment</b></span>
                <div class="col-md-10 col-sm-10">
                  <input type="text" id="txtClosureCommentBySLHR" name="txtClosureCommentBySLHR" maxlength="500"
                         class="form-control" [(ngModel)]="FTERecord.ClosureComments"
                         [disabled]="FTERecord.RequestStatusID == 9" autocomplete="off"
                         (keypress)="blockSpecialChar($event)" #txtClosureCommentBySLHR="ngModel" pattern="^[a-zA-Z0-9\s]*$">
                  <div *ngIf="((txtClosureCommentBySLHR.dirty || txtClosureCommentBySLHR.touched) && txtClosureCommentBySLHR.invalid)"
                       class="text-danger">Invalid input.</div>
                </div>
              </div>
            </div>
          </div> <!-- /.row  -->
        </div> <!-- /.panel-body  -->
      </div> <!-- /.closure-action-wrapper  -->
      <div class="current-compensation-wrapper" *ngIf="FTERecord.RequestStatusID == 13">
        <div class="panel-heading">
          <h4 class="panel-title">
            <a style="color: gray; font-size: 14px;">
              <b>Cancelled Remark</b>
            </a>
          </h4>
        </div>
        <div class="panel-body">
          <div class="row" style="padding-top:7px;">
                <div class="col-md-12">
                  <div class="row form-group">
                    <span class="col-sm-4"><b>Cancelled Remark </b></span>
                    <div class="col-md-8 col-sm-8">
                      <input type="textarea" id="txtCancelledRemark" name="txtCancelledRemark" maxlength="100" class="form-control"
                             [(ngModel)]="FTERecord.CancelledRemark" (keypress)="blockSpecialChar($event)" #txtRemark="ngModel" pattern="^[a-zA-Z0-9\s]*$"
                             [disabled]="true"
                             autocomplete="off">
                      <div *ngIf="((txtRemark.dirty || txtRemark.touched) && txtRemark.invalid)"
                           class="text-danger">Invalid input.</div>
                    </div>
                  </div>
                </div>
              </div>
        </div>
      </div>
    </div>
  </div>
</div>
